<template>
  <div :class='["headerbox",focus=="0" ? "headerbox1" : ""]'>
    <div class="left">
      <img src="../../public/statics/img/logo.png" alt="">
    </div>
    <div class="middle">
      <div :class="focus==1? 'middlesblack':'middles'" @click="jumppage(0)">
        首页
        <div v-show="focus==0" class="middlesfocus1"></div>
      </div>
      <div :class="focus==1? 'middlesblack':'middles'" @click="jumppage(1)">
        申请加入
        <div v-show="focus==1" class="middlesfocus2"></div>
        <div v-show="focus==6" class="middlesfocus1"></div>
      </div>
      <div :class="focus==1? 'middlesblack':'middles'" @click="jumppage(2)">
        支持中心
        <div v-show="focus==2" class="middlesfocus1"></div>
      </div>
      <div :class="focus==1? 'middlesblack':'middles'" @click="jumppage(3)">
        资讯动态
        <div v-show="focus==3" class="middlesfocus1"></div>
      </div>
      <div :class="focus==1? 'middlesblack':'middles'" @click="jumppage(4)">
        客服中心
        <div v-show="focus==4" class="middlesfocus1"></div>
      </div>
      <div :class="focus==1? 'middlesblack':'middles'" @click="jumppage(5)">
        生态云商城
        <div v-show="focus==5" class="middlesfocus1"></div>
      </div>
      <div :class="focus==1? 'middlesblack':'middles'" @click="jumppage(7)">
        云货主App
        <div v-show="focus==7" class="middlesfocus1"></div>
      </div>
      <div :class="focus==1? 'middlesblack':'middles'" @click="jumppage(8)">
        云车主App
        <div v-show="focus==8" class="middlesfocus1"></div>
      </div>
    </div>
    <div class="right">

      <div :class="focus==1? 'rightsos':'rightso'" v-if="status==1">
        <div style="display: flex;">
                   <span style="white-space:nowrap;
   text-overflow:ellipsis;
   overflow:hidden;
   max-width:1rem;
   display:block;margin-right: 5px;">{{ name }}</span>
          <span @click="logout()">退出</span>
        </div>
        <div class="rightso1">
          <span @click="jumplogistics()">登录云端</span>
        </div>
      </div>
      <div :class="focus==1? 'rightss':'rights'" v-else>
        <div>
          <span @click="showpsshow()">登录</span>
        </div>
        <div>
          /
        </div>
        <div>
          <span @click="jumplogistics()">登录云端</span>
        </div>

      </div>
      <el-form ref="form" :model="form" style="width: 100%" :rules="rules" @keyup.enter.native="addByEnterKey">
        <div v-show="psshow" class="login_son_box">
          <div class="chahao" @click="forgetClose">X</div>
          <div class="center">
            <div class="center_img" style="display: flex;flex-direction: column;">
              <p>用户登录</p>
              <span>欢迎使用IDA云物流管理系统</span>
            </div>
            <!--切换登录-->
            <div class="center_change">
              <div class="center_changes" :class="[logintype==1?'center_changeactive':'']"
                   @click="changelogintype(1)">短信登录
              </div>
              <div class="center_changes" :class="[logintype==2?'center_changeactive':'']"
                   @click="changelogintype(2)">密码登录
              </div>
            </div>
            <div class="input_up">
              <div class="input_up_style">
                <p><span>*</span>手机号:</p>
                <el-form-item prop="phone" style="height: 100%">
                  <el-input v-model="form.phone" placeholder="请输入"></el-input>
                </el-form-item>
              </div>
              <!--   <div class="input_up_style">
                  <p><span>*</span>密码:</p>
                  <el-form-item prop="password" style="height: 100%">
                      <el-input type="password" v-model="form.password"
                                show-password
                                placeholder="请输入"></el-input>
                  </el-form-item>
              </div>-->
              <div class="input_up_style" v-if="logintype==1">
                <p><span>*</span>验证码:</p>
                <el-form-item prop="code" style="height: 100%;">
                  <div style="display: flex;justify-content: space-between;">
                    <el-input type="code" v-model="form.code"
                              style="width:220px;"
                              placeholder="请输入"></el-input>
                    <el-button v-show="shows==true" type="primary"
                               style="width: 100px;padding: 0 10px;" @click="getcode()">获取验证码
                    </el-button>
                    <el-button v-show="shows==false" type="primary"
                               style="width: 100px;padding: 0 10px;">{{ count }}秒
                    </el-button>
                  </div>


                </el-form-item>
              </div>

              <div class="input_up_style" v-if="logintype==2">
                <p><span>*</span>密码:</p>
                <el-form-item prop="password" style="height: 100%">
                  <el-input type="password" v-model="form.password" placeholder="请输入"></el-input>
                </el-form-item>
              </div>
              <!--新功能-->
              <div style="display: flex;justify-content: space-between;">
                <el-checkbox v-model="rememberme" @change="setremember">记住我</el-checkbox>
                <span style="font-size: 14px;color: #409EFF;cursor:pointer;" @click="forgetVisble" v-if="logintype==2">忘记密码?</span>
              </div>


              <el-button type="primary" @click="submitForm" class="loginstyle">登录
              </el-button>

              <div class="input_up_style1" style="display: flex;justify-content: center;margin-top: 10px;">
                <div>
                  <i class="el-icon-info"></i>
                  <p>推荐使用谷歌浏览器</p>
                </div>
                <!--<span @click="">忘记密码?</span>-->
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>

    <!--      安全验证-->
    <el-dialog
        :visible.sync="isSafe"
        width="540px"
        custom-class="safeVerificatio"
        :append-to-body="true"
        :before-close="safeclost"
    >

      <div class="safeVerificatiobox">

        <img class="safe1" src="../../public/statics/img/safevila.png" alt="">
        <p class="safe2">安全验证</p>
        <p class="safe3">检测到您在新设备或异地登录，为了保护您的账户安全，需要进行身份验证</p>
        <div class="safe6">
          <div style="display: flex;margin-bottom: 6px; align-items: center;">
            <img src="../../public/statics/img/notice.png" style="width: 18px;height: 18px;margin-right: 10px;" alt="">
            检测到登录异常
          </div>
          <p style="margin-bottom: 10px;">登录地点: &nbsp;&nbsp; {{ safewarningInfo.address }} </p>
          <p>登录时间: &nbsp;&nbsp; {{ safewarningInfo.address_time }}</p>
        </div>
        <p class="safe4">短信验证码发送至手机 <span>{{ form.phone | reverse }}</span></p>
        <div class="safe5">
          <p> 短信验证码</p>
          <el-input v-model="safecode" placeholder="请输入验证码" style="width:270px;height: 48px;"></el-input>
          <el-button v-preventClick @click="getsafecode" type="primary" style="width: 100px;height: 48px;"
                     :disabled="safeshow">
            {{ safeshow ? safecout + '秒' : '发送验证码' }}
          </el-button>
        </div>
        <el-button v-preventClick type="primary" style="width: 478px;height: 48px;margin-bottom: 20px;"
                   @click="safeandlogin">验证并登录
        </el-button>
        <el-button style="width: 478px;margin-left: 0;height: 48px;" @click="safeclost(1)">取消登录</el-button>
      </div>

    </el-dialog>
  </div>


</template>

<script>
const TIME_COUNT = 60;
import {auth, loginauth, anth} from '../request/api';
import Cookies from 'js-cookie'
import {getToken, setToken, removeToken} from '../request/toekn'
import {mapGetters} from "vuex";
import FingerprintJS from '@fingerprintjs/fingerprintjs';

export default {
  name: "boxtop",
  props: {
    focus: Number
  },
  computed: {
    ...mapGetters(["name", "avatar", "companyname", "phone", "password"]),
  },
  data() {
    return {
      loading: false,
      //登录表单
      form: {
        phone: '',
        password: '',
        code: '',
        point_type: 1,
      },
      //登录验证
      rules: {
        phone: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur'},
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 8, message: '最少为8位', trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
        ],

      },
      //展示
      psshow: false,
      //登录状态
      status: 0,
      count: "",
      shows: true,

      logintype: 1,
      rememberme: false,
      /*安全验证*/
      isSafe: false,//安全验证
      safetimer: null,
      safecout: 60,
      safeshow: false,
      safecode: '',
      FingerprintID: null,
      safewarningInfo: {
        address: '',
        address_time: '',
      }
    }
  },
  filters: {
    // 局部过滤器：反转字符串
    reverse: function (value) {
      let str1 = value.slice(0, 3)
      let str2 = value.slice(-4)
      return str1 + '****' + str2
    }
  },
  created() {
    this.Fingerprint();
    this.isInIncognitoMode();
    this.rememberme = Lockr.get('isRemember') ? Lockr.get('isRemember') : false;
    if (Cookies.get(getToken()) && getToken()) {
      this.status = 1;
      this.getuserinfo()
    }
  },
  mounted() {
  },
  methods: {

    /*设备指纹*/
    async Fingerprint() {
      const result = await FingerprintJS.load();
      const visitorId = await result.get();
      // console.log(visitorId.visitorId); // 打印生成的指纹
      this.FingerprintID = visitorId.visitorId
    },
    async isInIncognitoMode() {
      try {
        const { quota } = await navigator.storage.estimate(); // 获取存储配额
        return quota < 120000000; // 阈值设为120MB（可根据实际情况调整）
      } catch {
        return true; // 若API调用失败（如旧浏览器），假设为无痕模式
      }
    },
    //关闭忘记密码
    forgetClose() {
      this.psshow = false;//关闭
      this.$refs['form'].resetFields();
      //验证码相关
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = null;
      this.count = TIME_COUNT;
      this.shows = false;
    },

    //忘记密码
    forgetVisble() {
      //去登录页修改密码
      window.location.replace(window.idomain + '/#/login?web=forget')
    },
    //记住我
    setremember() {
      if (this.rememberme == true) {
        Lockr.set('isRemember', true)
      } else {
        Lockr.set('isRemember', false)
      }
    },
    //切换登录方式
    changelogintype(e) {
      if (e == this.logintype) {
        return
      }
      this.$refs['form'].resetFields();
      this.logintype = e;
      this.form.code = '';
      this.form.password = '';
    },
    //标签页
    jumppage(e) {

      if (e == 0) {
        this.$router.push({path: '/index',});
      } else if (e == 1) {
        this.$router.push({path: '/edition',});
        /* if (Cookies.get(getToken()) && getToken()) {
             this.$router.push({path: '/edition',});
         } else {
             this.$router.push({path: '/apply',});
         }*/
      } else if (e == 2) {
        this.$router.push({path: '/word',});
      } else if (e == 3) {
        this.$router.push({path: '/newviews',});
      } else if (e == 4) {
        this.$router.push({path: '/chat',});

        // window.open('https://tb.53kf.com/code/client/daa8b04cbb02352f2449873bb79aebfa8/1', '_blank');
      } else if (e == 5) {

        this.$router.push({path: '/shop',});

        // window.open('https://tb.53kf.com/code/client/daa8b04cbb02352f2449873bb79aebfa8/1', '_blank');
      } else if (e == 7) {
        this.$router.push({path: '/cargoOwner',});
      } else if (e == 8) {
        this.$router.push({path: '/carOwner',});
      }
    },
    //显示登录列表
    showpsshow() {
      this.psshow = true;
    },
    addByEnterKey(e) {
      //Enter键的代码就是13
      if (e.keyCode == 13) {
        this.submitForm();
      }
    },

    getuserinfo() {
      this.$store.dispatch('GetInfo').then(data => {
        // console.log('成功')
      }).catch((data) => {
        if (data.data.code == 8000) {
          this.logout();
          this.loading = false;
        } else {
          this.$message.error(data.data.msg);
          this.loading = false;
          return false;
        }
      })
    },
    //登录表单提交
    submitForm(form) {
      // this.loading = true;
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let APIstr = '';//
          let code = {
            phone: this.form.phone, //手机号
            FingerprintID: this.FingerprintID,
            user_agent:1,
            /*  type: 1,//2.3单点登录新增
            point_type:this.form.point_type,
            code: this.form.code, //验证码
            // password: this.form.password, //密码*/
          };

          //textlogin
          if (this.logintype == 1) {
            code.type = 1;
            code.point_type = this.form.point_type;
            code.code = this.form.code
            APIstr = 'Login'
          }
          //passlogin
          if (this.logintype == 2) {
            code.password = this.form.password
            APIstr = 'PassLogin'
          }
          Cookies.remove();
          removeToken();

          this.$store.dispatch(APIstr, code).then(data => {
            this.loading = false;
            if (Cookies.get(getToken()) && getToken()) {

              loginauth().then(res => {
                if (res.data.code == 1) {

                  let menus = res.data.data.menu;
                  if (menus != '') {
                    if (menus.user) {
                      Lockr.set('user', menus.user.children);
                    }
                    if (menus.transport) {
                      Lockr.set('transport', menus.transport.children);
                    }
                    if (menus.packing) {
                      Lockr.set('packing', menus.packing.children);
                    }
                    if (menus.storage) {
                      Lockr.set('storage', menus.storage.children);
                    }
                  }

                  let buttonauth = res.data.data.auth_code;
                  Lockr.set('authbuttons', buttonauth);
                  let wordobj = {
                    transportword: res.data.data.yunshu,
                    packingword: res.data.data.baozhuang,
                    storeword: res.data.data.cangchu
                  };
                  let videoauth = {
                    transportvideo: res.data.data.video_menu.transport,
                    packingvideo: res.data.data.video_menu.packing,
                    storevideo: res.data.data.video_menu.storage,
                  }
                  Lockr.set('videoauths', videoauth);
                  Lockr.set('wordauth', wordobj);

                  this.getuserinfo();
                  this.$message({
                    type: 'success',
                    message: '登录成功'
                  });
                  this.status = 1;
                  this.$router.push({path: '/index',});
                  this.psshow = false;

                } else {
                  this.$message({
                    type: 'error',
                    message: res.data.msg
                  });
                  setTimeout(() => {
                    this.logout();
                  }, 500);
                  return;
                }
              });

            }
          }).catch((data) => {
            // this.$message.error(data);
            if (data.code == 8102) {
              this.$confirm(data.msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.form.point_type = 2;
                this.submitForm();
              })
            } else if (data.code == 3) {

              if (data.data.count_error == 0) {
                let warningstr = '账号已锁定，请30分钟后重试或找回密码!';
                this.$confirm(warningstr, '提示', {
                  showCancelButton: false,
                  showConfirmButton: false,
                  type: 'error'
                }).then(() => {
                })
              } else if (data.data.count_error >= 3) {
                let warningstr = '您的账户由于多次尝试登录失败，即将被锁定。建议您： 通过【短信验证码】继续登录或通过【忘记密码】重置后再登录!';
                this.$confirm(warningstr, '提示', {
                  showCancelButton: false,
                  showConfirmButton: false,
                  type: 'error'
                }).then(() => {
                })
              } else {
                this.$message({
                  type: 'error',
                  message: '密码错误!'
                })
              }
            } else if (data.code == 99999 || data.code == 100000) {
              this.isSafe = true;//触发安全验证
              this.safewarningInfo.address = JSON.parse(JSON.stringify(data.data.address));
              this.safewarningInfo.address_time = JSON.parse(JSON.stringify(data.data.address_time));
            } else {
              this.$message({
                type: 'error',
                message: data.msg
              })
            }
            this.loading = false

          })
        } else {
          console.log('error submit!!');
          return false;

        }
      });

    },
    // 退出登录
    logout() {
      this.$store.dispatch('LogOut').then(data => {
        this.$message({
          type: 'success',
          message: '退出成功',
        });
        this.status = 0;
        this.$router.push({path: '/index',});
      }).catch((data) => {
        this.$message.error(data.data.msg);
        this.loading = false;
      })
    },
    //进入系统
    jumplogistics() {
      // console.log(this.phone);
      // return;
      if (Cookies.get(getToken()) && getToken()) {
        //判断是否能跳转各大中心
        if (Lockr.get("transport")) {
          Cookies.set('cate', 1)
          window.location.replace(window.idomain)//正式环境
          return;
        }
        if (Lockr.get("storage")) {
          Cookies.set('cate', 5)
          window.location.replace(window.idomains)//正式环境
          return;
        }
        if (Lockr.get("packing")) {
          Cookies.set('cate', 2)
          window.location.replace(window.idomains)//正式环境
          return;
        }

      } else {
        window.location.replace(window.idomain)//正式环境
      }

    },
    //获取验证码
    getcode() {
      if (this.form.phone == undefined || this.form.phone == '') {
        this.$message({
          type: "warning",
          message: "请先输入手机号"
        })
      } else {
        let url = '/v1/member/login/send_sms';
        let data = {
          phone: this.form.phone,
          type: 1,
        };
        auth(url, data).then(res => {
          if (res.data.code == 1) {
            this.$message({
              type: "success",
              message: "发送成功"
            })
            this.count = TIME_COUNT;
            this.shows = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.shows = true;
                clearInterval(this.timer);  // 清除定时器
                this.timer = null;
              }
            }, 1000)
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      }

    },

    //安全验证-获取验证
    getsafecode() {
      if (this.form.phone == '') {
        this.$message.warning('请输入手机号!');
        return;
      }
      let url = '/v1/member/login/send_sms';
      let data = {
        phone: this.form.phone
      }
      auth(url, data).then(res => {
        if (res.data.code == 1) {
          this.safeshow = true;
          this.safetimer = setInterval(() => {
            this.safecout--;
            if (this.safecout == 0) {
              clearInterval(this.safetimer);
              this.safetimer = null;
              this.safecout = 60;
              this.safeshow = false;
            }
          }, 1000)
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    safeclost(e) {
      this.safetimer = null;
      this.safecout = 60;
      this.safeshow = false;
      this.isSafe = false;
      if (!e) {
        //验证登录
        this.form.code = this.safecode;
        this.safecode = '';
      }

    },
    //验证并登录
    safeandlogin() {
      this.safeclost();
      //验证登录
      this.logintype = 1;
      setTimeout(() => {
        this.submitForm();
      }, 500)
    },
  },
}
</script>

<style scoped lang='scss'>
.headerbox {
  position: fixed;
  z-index: 999;
  top: 0;
  width: 100%;
  height: 0.6rem;
  /*background: antiquewhite;*/
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left {
    /*width: 2rem;*/
    height: 0.48rem;
    margin-left: 0.5rem;

    img {
      /*width: 100%;*/
      height: 100%;
    }
  }

  .middle {
    display: flex;

    .middles {
      width: 1.5rem;
      font-family: "PingFang SC";
      font-size: 0.2rem;
      cursor: pointer;
      color: #fff;
      position: relative;
    }

    .middlesfocus1 {
      display: block;
      content: "";
      position: absolute;
      width: 0.25rem;
      height: 0.04rem;
      background: #fff;
      left: 0;
      right: 0;
      bottom: -0.12rem;

      margin: auto;
      border-radius: 2px;
    }

    .middlesblack {
      width: 1.5rem;
      font-family: "PingFang SC";
      font-size: 0.2rem;
      cursor: pointer;
      color: #333;
      position: relative;
    }

    .middlesfocus2 {
      display: block;
      content: "";
      position: absolute;
      width: 0.25rem;
      height: 0.04rem;
      background: #333;
      left: 0;
      right: 0;
      bottom: -0.12rem;
      margin: auto;
      border-radius: 2px;
    }

  }

  .right {
    position: relative;
    margin-right: 40px;
    font-family: "PingFang SC";

    .rights {
      width: 1.8rem;
      height: 0.4rem;
      display: flex;
      border: 2px solid #ffffff;
      color: #ffffff;
      justify-content: space-around;
      align-items: center;
      font-size: 0.18rem;
      border-radius: 60px;
      padding: 0 10px;

      span {
        cursor: pointer;
        text-align: center;
        line-height: 0.4rem;
      }
    }

    .rightss {
      width: 1.8rem;
      height: 0.4rem;
      display: flex;
      border: 2px solid #777;
      color: #333;
      justify-content: space-around;
      align-items: center;
      border-radius: 60px;
      font-size: 0.18rem;
      padding: 0 10px;

      span {
        cursor: pointer;
        text-align: center;
        line-height: 0.4rem;
      }
    }

    .rightso {
      width: 3rem;
      height: 0.4rem;
      display: flex;
      color: #ffffff;
      justify-content: space-around;
      align-items: center;
      font-size: 0.18rem;

      .rightso1 {
        width: 1.2rem;
        height: 0.4rem;
        line-height: 0.4rem;
        border: 2px solid #ffffff;
        border-radius: 60px;


      }

      span {
        cursor: pointer;
      }
    }

    .rightsos {
      width: 3rem;
      height: 0.4rem;
      display: flex;
      color: #333;
      justify-content: space-around;
      align-items: center;
      font-size: 0.18rem;

      .rightso1 {
        width: 1.2rem;
        height: 0.4rem;
        line-height: 0.4rem;
        border: 2px solid #777;
        border-radius: 60px;

      }

      span {
        cursor: pointer;
      }
    }

    .login_son_box {
      position: absolute;
      top: 60px;
      right: 20px;
      margin: auto;
      width: 380px;
      height: 460px;
      background: rgba(255, 255, 255, 1);
      box-shadow: -1px 1px 35px -3px rgba(0, 0, 0, 0.15);
      -webkit-box-shadow: -1px 1px 35px -3px rgba(0, 0, 0, 0.15);
      -moz-box-shadow: -1px 1px 35px -3px rgba(0, 0, 0, 0.15);
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .chahao {
        position: absolute;
        right: 20px;
        top: 10px;
        font-size: 16px;
        cursor: pointer;
        z-index: 9999;
      }

      .registerstyle {
        width: auto;
        height: auto;
        font-size: 20px;
        cursor: pointer;
        margin: 20px 0 0 0;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #4597FF;
      }

      .center {
        width: 100%;
        height: auto;
        padding: 0 20px 0 20px;
        box-sizing: border-box;
        margin-top: 6px;

        .center_img {
          width: 100%;
          height: 39px;
          display: flex;
          /*margin-bottom: 11px;*/
          justify-content: center;
          margin: 30px 0 10px;

          p {
            width: auto;
            height: 50px;
            font-size: 30px;
            font-family: 'PingFang SC';
            /*font-weight: bold;*/
            line-height: 41px;
            color: #2B2C44;
          }

          span {
            margin-bottom: 20px;
          }
        }

        /*切换登录*/
        .center_change {
          padding: 8px 10px;
          box-sizing: border-box;
          background: #F7F7FA;

          display: flex;

          margin-bottom: 10px;

          .center_changes {
            width: 160px;
            height: 32px;
            text-align: center;
            line-height: 32px;
            font-size: 16px;
            color: #333333;
            cursor: pointer;
          }

          .center_changeactive {
            width: 160px;
            height: 32px;
            background: #FFFFFF;
            color: #409EFF;
            font-weight: bold;
          }
        }

        .input_up {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .input_up_style {
            height: 94px;
            display: flex;
            flex-direction: column;

            p {
              font-size: 14px;
              font-family: "PingFang SC";
              line-height: 24px;
              color: #606266;
              text-align: left;

              span {
                color: #F35959;
                margin-right: 5px;
              }
            }
          }

          .input_up_style1 {
            height: 16px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            div {
              display: flex;

              i {
                font-size: 16px;
                color: #FBA962;
                line-height: 20px;
              }

              p {

                font-size: 14px;
                font-family: "PingFang SC";
                color: #606266;
                line-height: 20px;
              }
            }

            span {
              font-size: 14px;
              line-height: 20px;
              font-family: "PingFang SC";
              color: #3D68EB;
              cursor: pointer;
            }

          }

          .loginstyle {
            width: 100%;
            height: 52px;
            padding: 0 10px;
            font-size: 16px;
            cursor: pointer;
            margin-top: 10px;
          }
        }

        .center_bottom {
          width: 100%;
          height: 16px;
          margin-top: 50px;
          display: flex;
          justify-content: space-between;

          .jump-icon {
            background: #666;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 14px;
            height: 14px;
            font-size: 10px;
            color: #fff;
            margin-right: 5px;
          }

          .jump-bar {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #595959;
            padding-right: 10px;
            cursor: pointer;
          }

          .jump-bar:hover {
            color: #66B1E1;
          }
        }
      }

    }

  }


}

/*安全验证*/
.safeVerificatiobox {
  display: flex;
  flex-direction: column;
  align-items: center;

  .safe1 {
    width: 68px;
    height: 68px;
    margin-bottom: 10px;
  }

  .safe2 {
    font-size: 30px;
    color: #333333;
    margin: 6px 0;
    font-weight: bold;
  }

  .safe3 {
    font-size: 12px;
    color: #999999;
    line-height: 40px
  }

  .safe4 {
    width: 478px;
    font-size: 12px;
    color: #999999;
    margin-bottom: 20px;
  }

  .safe5 {
    width: 478px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    p {
      font-size: 16px;
      color: #2B2C44;
    }

  }

  .safe6 {
    width: 478px;
    padding: 16px;
    box-sizing: border-box;
    font-size: 12px;
    color: #FF7929;
    background: rgba(255, 121, 41, .16);
    border-radius: 4px;
    margin-bottom: 20px;
  }

}

.headerbox1 {
  background: #005f88;
}
</style>
<style lang="scss">
.safeVerificatio {
  .el-dialog__header {
    padding: 0;
  }

  .el-input__inner {
    height: 48px !important;
  }
}
</style>
